// icons are served by admsite itself from the static/ folder
const imagesPath = window.location.origin;
export const staticImagesRelativePath: {
  integrationIcons: {
    [key: string]: () => string;
  };
  aiProviderIcons: {
    [key: string]: () => string;
  };
  oauthIcons: {
    [key: string]: () => string;
  };
} = {
  // an unknown provider falls back to DEFAULT and is rendered as a monogram
  aiProviderIcons: {
    OPEN_AI: () => `${imagesPath}/static/ai-40-40/open_ai_logo.svg`,
    GEMINI: () => `${imagesPath}/static/ai-40-40/gemini_logo.svg`,
    DEEPSEEK: () => `${imagesPath}/static/ai-40-40/deepseek_logo.svg`,
    // FLUX is made by Black Forest Labs, so their mark stands for both ways of reaching it
    FLUX2API: () => `${imagesPath}/static/ai-40-40/flux_logo.svg`,
    BFL: () => `${imagesPath}/static/ai-40-40/flux_logo.svg`,
    KLINGAI: () => `${imagesPath}/static/ai-40-40/klingai_logo.svg`,
    // ModelArk is a BytePlus platform, so the BytePlus mark stands for it: taken from byteplus.com (the
    // footer logo, white there) and recoloured to the brand blue the site uses, #0066FC
    MODELARK: () => `${imagesPath}/static/ai-40-40/modelark_logo.svg`,
    DEFAULT: () => '',
  },
  oauthIcons: {
    GOOGLE: () => `${imagesPath}/static/oauth-40-40/google_logo.png`,
    DEFAULT: () => '',
  },
  integrationIcons: {
    GOOGLE_DRIVE: () => `${imagesPath}/static/integration-40-40/google_drive_logo.svg`,
    DROPBOX: () => `${imagesPath}/static/integration-40-40/dropbox_logo.svg`,
    DEFAULT: () => '',
  },
};
